import React, { useRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import { connect, getIn } from "formik";
import classes from "./styles.module.scss";

export const formikMuiSelectField = (Component) => {
  const Field = muiSelectField(Component);

  const ConnectedCp = connect(
    ({ formik, name, innerRef, onChange, ...props }) => (
      <Field
        ref={innerRef}
        value={getIn(formik.values, name)}
        onChange={(value) => {
          formik.setFieldValue(name, value);
          if (typeof onChange === "function") onChange(value);
        }}
        {...props}
      />
    )
  );

  return React.forwardRef((props, ref) => (
    <ConnectedCp {...props} innerRef={ref} />
  ));
};

const muiSelectField = (Component) => {
  const MuiSelectField = React.forwardRef(
    ({ value, label, className = "", ...props }, initialRef) => {
      const ref = useRef(null);

      useImperativeHandle(initialRef, () => ({
        focus: () => ref.current.focus(),
      }));

      return (
        <div
          className={cl(classes.MuiSelectFieldContainer, className, {
            [classes["MuiSelectFieldContainer--has-value"]]: !!value,
          })}
        >
          <label
            className={classes.MuiSelectField__label}
            onClick={() => ref.current.focus()}
          >
            {label}
          </label>
          <Component
            ref={ref}
            className={classes.muiField}
            value={value}
            placeholder=""
            {...props}
          />
        </div>
      );
    }
  );

  MuiSelectField.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
  };

  return MuiSelectField;
};

export default muiSelectField;
